export const MODAL_TYPE_CREATE_POST = 'create-post';
export const MODAL_TYPE_DISCARD_POST = 'discard-post';
export const MODAL_TYPE_CHANGE_CATEGORY = 'change-category';
export const MODAL_TYPE_DELETE_COMMENT = 'delete-comment';
export const MODAL_TYPE_DELETE_POST = 'delete-post';
export const MODAL_TYPE_DELETE_CATEGORY = 'delete-category';
export const MODAL_TYPE_PROFILE_ACTIONS = 'profile-actions';
export const MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART = 'profile-actions-upper-part';
export const MODAL_TYPE_MOVE_POST = 'move-post';
export const MODAL_TYPE_REPORT_COMMENT = 'report-comment';
export const MODAL_TYPE_REPORT_POST = 'report-post';
export const MODAL_TYPE_REPORT_MEMBER = 'report-member';
export const MODAL_TYPE_PROMOTE_MODERATOR = 'promote-member';
export const MODAL_TYPE_DEMOTE_MODERATOR = 'demote-member';
export const MODAL_TYPE_UNFOLLOW_MEMBER = 'unfollow-member';
export const MODAL_TYPE_BLOCK_MEMBER = 'block-member';
export const MODAL_TYPE_UNBLOCK_MEMBER = 'unblock-member';
export const MODAL_TYPE_SHARE_POST = 'share-post';
export const MODAL_TYPE_SHARE_LINK = 'share-link';
export const MODAL_TYPE_SHARE_COMMENT = 'share-comment';
export const MODAL_TYPE_LOGIN = 'login';
export const MODAL_TYPE_TEXT_EDITOR_LINK = 'text-editor-link';
export const MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED = 'text-editor-video-embed';
export const MODAL_TYPE_DEMO_MODE = 'demo-mode';



// WEBPACK FOOTER //
// ./app/constants/modal-types.js